import { SecurityConstants } from './../../../security/constants/security-constants';
import { Title } from '@angular/platform-browser';
import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { PasswordReset } from '../../../security/models/password-reset';
import { SecurityService } from '../../../security/services/security.service';

@Component({
  selector: 'app-password-reset',
  templateUrl: './password-reset.component.html',
  styleUrls: ['./password-reset.component.css'],
})
export class PasswordResetComponent implements OnInit, OnDestroy {
  formTouched = false;
  formSubmitted = false;
  passwordReset: PasswordReset = new PasswordReset();
  showSuccess: boolean = true;
  sub: Subscription | null = null;
  invalidToken: boolean = false;

  constructor(private securityService: SecurityService, private activatedRoute: ActivatedRoute, @Inject('IMAGES_URL') public imagesUrl: string) {}
  getImage = () => "url('assets/images/texture-1.png')";
  private paramsSubscriptionProcess = (params: any): void => {
    this.passwordReset.token = decodeURIComponent(<string>this.activatedRoute.snapshot.queryParamMap.get('token'));
    this.passwordReset.username = this.activatedRoute.snapshot.queryParamMap.get('username');
  };

  ngOnInit(): void {
    this.sub = this.activatedRoute.params.subscribe(this.paramsSubscriptionProcess);
  }

  invalidTokenMessage: string = '';

  onSubmit(form: any): void {
    this.formTouched = true;
    if (!form.valid) return;

    this.formSubmitted = true;

    this.securityService.resetPassword(this.passwordReset).subscribe(
      (res) => (this.showSuccess = true),
      (err) => {
        if (err && err.error && err.error[0] && err.error[0].code == SecurityConstants.INVALID_TOKEN) {
          this.invalidToken = true;
          this.invalidTokenMessage = err.error[0].description;
        }

        this.formSubmitted = false;
      }
    );
  }

  ngOnDestroy(): void {
    if (this.sub != null) this.sub.unsubscribe();
  }
}
